import uniRouter from "./uni-router.js";

export default function () {
    // 重构初始化
    for (const key in uniRouter) {
        uni[key] && (uni[key] = uniRouter[key])
    }
}